<template>
  <v-container fluid>
    <v-card flat class="exams">
      <v-card-title> Exempted Units </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="studentResults"
          item-key="id"
          class="itemRow"
          :sort-by="['dueDate']"
          :sort-desc="[false]"
          :items-per-page="5"
        >
          <!--BEGIN result ID-->
          <template v-slot:[`item.id`]="{ index }">
            <span class="table-exam">{{ index + 1 }}</span>
          </template>
          <!--END result ID-->
          <!--BEGIN unit code-->
          <template v-slot:[`item.unitCode`]="{ item }">
            <span class="table-exam"> {{ item["unitCode"] }}</span>
          </template>
          <!--END unit code-->
          <!--BEGIN year-->
          <template v-slot:[`item.year`]="{ item }">
            <span class="table-exam"> {{ item["year"] }}</span>
          </template>
          <!--END year-->
          <!--BEGIN programme-->
          <template v-slot:[`item.programme`]="{ item }">
            <span class="table-exam"> {{ item["programme"] }}</span>
          </template>
          <!--END programme-->
          <!--BEGIN unit name-->
          <template v-slot:[`item.description`]="{ item }">
            <span class="table-exam">
              <span class="">[{{ item["unitCode"] }}] </span>
              {{ item["description"] }}
            </span>
          </template>
          <!--END unit name-->
          <!--BEGIN sittings-->
          <template v-slot:[`item.sitting`]="{ item }">
            <span class="table-exam"> {{ item["sitting"] }}</span>
          </template>
          <!--END sittings-->
          <!--BEGIN result-->
          <template v-slot:[`item.result`]="{ item }">
            <span class="table-exam"> {{ item["result"] }}</span>
          </template>
          <!--END result-->
          <!--BEGIN grade-->
          <template v-slot:[`item.grade`]="{ item }">
            <span class="table-exam"> {{ item["grade"] }}</span>
          </template>
          <!--END grade-->
          <!--BEGIN status-->
          <template v-slot:[`item.status`]="{ item }">
            <span class="table-exam text-lowercase"
              ><v-icon size="12" color="teal">mdi-radiobox-marked</v-icon>
              {{ item["status"] }}</span
            >
          </template>
          <!--END status-->
          <!--BEGIN board actions-->
          <template v-slot:[`item.action`]="{}">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <span class="table-exam"
                    ><v-icon color="primary" size="">mdi-eye</v-icon> View</span
                  >
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <span class="table-exam"
                    ><v-icon color="secondary" size=""
                      >mdi-cloud-download</v-icon
                    >
                    Download</span
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <!--END board actions-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { AuthService } from "@/packages/dashboard/modules/auth";

export default {
  name: "examCurrentResults",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("Exam/studentExamResults");
      window.document.title = "KISEB::Current Results";
    });
  },
  data: () => ({
    headers: [
      {
        text: "S/N",
        align: "left",
        sortable: false,
        value: "id",
      },
      {
        text: "Year",
        align: "left",
        sortable: false,
        value: "year",
      },
      {
        text: "Programme",
        align: "left",
        sortable: false,
        value: "programme",
      },
      {
        text: "Unit Description",
        align: "left",
        sortable: false,
        value: "description",
      },
      {
        text: "Attempts",
        align: "center",
        sortable: false,
        value: "sitting",
      },
      {
        text: "Grade",
        align: "left",
        sortable: false,
        value: "grade",
      },
      {
        text: "Result",
        align: "left",
        sortable: false,
        value: "result",
      },
      {
        text: "Status",
        align: "left",
        sortable: false,
        value: "status",
      },
      {
        text: "Action",
        align: "left",
        sortable: false,
        value: "action",
      },
    ],
  }),
  computed: {
    studentProfileID() {
      return AuthService.user.profile_id;
    },
    studentResults() {
      return this.$store.getters["Exam/studentExamGetter"](
        "studentResults",
      ).filter(
        (item) =>
          item.status === "Current" && item.profileID === this.studentProfileID,
      );
    },
  },
};
</script>

<style scoped>
@import url("../styles/exam.css");
</style>
